<form #addLocationForm="ngForm" name="addLocationForm">
    <div mat-dialog-title class="modal-header">
        <button
            *ngIf="!createLocationButtonLoader"
            mat-dialog-close
            class="close close-btn"
            aria-label="Close"
            type="button"
            (click)="resetLocationForm(addLocationForm); clearLocationData()"
        >
            <i class="fa fa-close"></i>
        </button>
        <h4 class="modal-title">Create Location</h4>
    </div>

    <mat-dialog-content>
        <div class="modal-body">
            <div class="member-card">
                <h4 class="filter-options">Address Details</h4>
                <hr class="hr-class" />
                <div class="col-md-12">
                    <div class="row">
                        <input
                            id="reusableAutocompleteAddress"
                            class="form-control mb-4"
                            #pick
                            name="searchAddr"
                            placeholder="Search"
                            type="text"
                            [(ngModel)]="searchedAddr"
                            (ngModelChange)="autoSearchAddress()"
                        />
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-md-12">
                        <label>Location Name</label><span class="text-danger"> * </span>
                        <input
                            id="addressName"
                            class="form-control"
                            #addressName="ngModel"
                            maxlength="255"
                            name="addressName"
                            placeholder="Location Name"
                            required
                            type="text"
                            [ngClass]="{ 'is-invalid': addLocationForm.submitted && addressName.invalid }"
                            [(ngModel)]="Location.addressName"
                        />
                        <div *ngIf="addLocationForm.submitted && addressName.invalid" class="invalid-feedback">
                            <div *ngIf="addressName.errors.required"><span class="text-danger">Location Name is required.</span></div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Address Type</label><span class="text-danger"> * </span>
                            <select
                                class="form-control"
                                #addressType="ngModel"
                                name="addressType"
                                required
                                [ngClass]="{ 'is-invalid': addLocationForm.submitted && addressType.invalid }"
                                [(ngModel)]="Location.LocationAddressType"
                            >
                                <option disabled selected [value]="null">Select Address Type</option>
                                <option *ngFor="let item of AddressType" name="addr_type" [value]="item">
                                    {{ item }}
                                </option>
                            </select>
                            <div *ngIf="addLocationForm.submitted && addressType.invalid" class="invalid-feedback">
                                <div *ngIf="addressType.errors.required"><span class="text-danger">Address Type is required.</span></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Address</label><span class="text-danger"> * </span>
                            <div class="radio my-0">
                                <label>
                                    <input
                                        #pvtOrPublic="ngModel"
                                        name="pvtOrPublic"
                                        type="radio"
                                        [value]="false"
                                        [(ngModel)]="Location.isGlobal"
                                        (click)="Location.airportCode = null"
                                    />Private
                                </label>
                                <label class="ml-4">
                                    <input
                                        #pvtOrPublic="ngModel"
                                        name="pvtOrPublic"
                                        type="radio"
                                        [value]="true"
                                        [(ngModel)]="Location.isGlobal"
                                        (click)="Location.airportCode = null"
                                    />Public
                                </label>
                                <label class="ml-4">
                                    <input
                                        #pvtOrPublic="ngModel"
                                        name="pvtOrPublic"
                                        type="radio"
                                        [value]="null"
                                        [(ngModel)]="Location.isGlobal"
                                    />Airport
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="Location.isGlobal == null" class="row form-group">
                    <div class="col-md-6">
                        <label>Airport Code </label><span class="text-danger"> * </span>
                        <button
                            *ngIf="!isShowAddAirportCode"
                            id="addAirportCode"
                            class="plus-icon"
                            title="Add Airport Code"
                            type="button"
                            (click)="isShowAddAirportCode = true"
                        >
                            <i class="fa fa-plus-circle"></i>
                        </button>
                        <button
                            *ngIf="isShowAddAirportCode"
                            class="plus-icon"
                            title="Cancel Add Airport Code"
                            type="button"
                            (click)="isShowAddAirportCode = false; airport = ''"
                        >
                            <i class="fa fa-times-circle"></i>
                        </button>
                        <div *ngIf="isShowAddAirportCode">
                            <div class="col-md-8 px-0">
                                <input
                                    class="form-control"
                                    #airportCodeName="ngModel"
                                    maxlength="4"
                                    minlength="3"
                                    name="airportCodeName"
                                    placeholder="Enter Airport Code"
                                    required
                                    type="text"
                                    [value]="airport | uppercase"
                                    [(ngModel)]="airport"
                                />
                            </div>
                            <div class="col-md-4 pr-0">
                                <button
                                    class="flat-butt flat-info-butt flat-info-grad-butt btn-size save-btn col-md-12"
                                    type="button"
                                    (click)="addAirportCode()"
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                        <select
                            *ngIf="!isShowAddAirportCode"
                            class="form-control"
                            #airportCode="ngModel"
                            name="airportCode"
                            required
                            [ngClass]="{ 'is-invalid': addLocationForm.submitted && airportCode.invalid }"
                            [(ngModel)]="Location.airportCode"
                        >
                            <option disabled selected [value]="null">Select Airport Code</option>
                            <option *ngFor="let item of airportCodeList" name="state" [value]="item.airportCode">
                                {{ item?.airportCode }}
                            </option>
                        </select>
                        <!---todo commented as airportCode is not exist-->
                        <!--<div *ngIf="addLocationForm.submitted && airportCode && airportCode.invalid"
                            class="invalid-feedback">
                            <div *ngIf="airportCode.errors.required">
                                <span class="text-danger">
                                    Airport Code is required.
                                </span>
                            </div>
                        </div>-->
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-md-6">
                        <label>Street Address</label><span class="text-danger"> * </span>
                        <input
                            id="aContact_StreetAddress"
                            class="form-control"
                            #streetAddress="ngModel"
                            maxlength="150"
                            name="streetAddress"
                            pattern="^[^\s]+(\s+[^\s]+)*$"
                            placeholder="Street Address"
                            required
                            type="text"
                            [ngClass]="{ 'is-invalid': addLocationForm.submitted && streetAddress.invalid }"
                            [(ngModel)]="Location.streetAddress"
                        />
                        <div *ngIf="addLocationForm.submitted && streetAddress.invalid" class="invalid-feedback">
                            <div *ngIf="streetAddress.errors.required"><span class="text-danger">Street Address is required.</span></div>
                            <div *ngIf="streetAddress.errors.pattern"><span class="text-danger">Street Address not valid.</span></div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <label>Zipcode</label><span class="text-danger"> * </span>
                        <input
                            id="acZipCode"
                            class="form-control"
                            #Zipcode="ngModel"
                            maxlength="5"
                            minlength="3"
                            name="Zipcode"
                            pattern="[A-Za-z0-9]+"
                            placeholder="Zipcode"
                            required
                            type="text"
                            [ngClass]="{ 'is-invalid': addLocationForm.submitted && Zipcode.invalid }"
                            [(ngModel)]="Location.zipcode"
                        />
                        <div *ngIf="addLocationForm.submitted && Zipcode.invalid" class="invalid-feedback">
                            <div *ngIf="Zipcode.errors.required"><span class="text-danger">Zipcode is required.</span></div>
                            <div *ngIf="Zipcode.errors.minlength"><span class="text-danger">Zipcode must have 3 or 5 digits.</span></div>
                            <div *ngIf="Zipcode.errors.pattern"><span class="text-danger">Zipcode not valid.</span></div>
                        </div>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-md-6">
                        <label>State </label><span class="text-danger"> * </span>
                        <select
                            class="form-control"
                            #state="ngModel"
                            name="state"
                            required
                            [ngClass]="{ 'is-invalid': addLocationForm.submitted && state.invalid }"
                            [(ngModel)]="Location.stateId"
                            (change)="getCityByState(Location.stateId)"
                        >
                            <option disabled selected value="">Select State</option>
                            <option *ngFor="let item of stateList" name="state" [value]="item.stateId">
                                {{ item?.stateName }}
                            </option>
                        </select>
                        <div *ngIf="addLocationForm.submitted && state.invalid" class="invalid-feedback">
                            <div *ngIf="state.errors.required"><span class="text-danger">State is required.</span></div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <label>City</label><span class="text-danger"> * </span>
                        <button
                            *ngIf="isCityButtonShow && !isShowAddCity"
                            id="addLocationPopUp"
                            class="plus-icon"
                            title="Add City"
                            type="button"
                            (click)="isShowAddCity = true"
                        >
                            <i class="fa fa-plus-circle"></i>
                        </button>
                        <button
                            *ngIf="isShowAddCity"
                            class="plus-icon"
                            title="Cancle Add City"
                            type="button"
                            (click)="isShowAddCity = !isShowAddCity; cityAdd.cityName = ''"
                        >
                            <i class="fa fa-times-circle"></i>
                        </button>
                        <div *ngIf="isShowAddCity">
                            <form #cityform="ngForm" name="cityform">
                                <div class="col-md-8 px-0">
                                    <input
                                        class="form-control"
                                        #city="ngModel"
                                        name="city"
                                        placeholder="Enter City Name"
                                        required
                                        type="text"
                                        [ngClass]="{ 'is-invalid': cityform.submitted && city.invalid }"
                                        [(ngModel)]="cityAdd.cityName"
                                    />
                                    <div *ngIf="cityform.submitted && city.invalid" class="invalid-feedback">
                                        <div *ngIf="city.errors.required"><span class="text-danger">Enter City name.</span></div>
                                    </div>
                                </div>
                                <div class="col-md-4 pr-0">
                                    <button
                                        class="flat-butt flat-info-butt flat-info-grad-butt btn-size save-btn col-md-12"
                                        type="submit"
                                        (click)="addCity()"
                                    >
                                        Save
                                    </button>
                                </div>
                            </form>
                        </div>
                        <select
                            *ngIf="!isShowAddCity"
                            class="form-control"
                            #city="ngModel"
                            name="city"
                            required
                            [ngClass]="{ 'is-invalid': addLocationForm.submitted && state.invalid }"
                            [(ngModel)]="Location.cityId"
                        >
                            <option disabled selected value="">Select City</option>
                            <option *ngFor="let item of cityList" name="city" [value]="item.cityId">
                                {{ item?.cityName }}
                            </option>
                        </select>
                        <div *ngIf="addLocationForm.submitted && state.invalid" class="invalid-feedback">
                            <div *ngIf="state.errors.required"><span class="text-danger">City is required.</span></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions class="mat-dialog-actions-style">
        <button
            mat-dialog-close
            class="flat-butt flat-danger-butt flat-danger-grad-butt margin-right-10"
            type="button"
            [disabled]="createLocationButtonLoader"
            (click)="resetLocationForm(addLocationForm); clearLocationData()"
        >
            Cancel
        </button>
        <button
            class="flat-butt flat-info-butt flat-info-grad-butt save-btn"
            type="submit"
            [disabled]="isShowAddAirportCode"
            (click)="addLocation(addLocationForm.form)"
        >
            Save Changes
            <span *ngIf="createLocationButtonLoader" class="ml-3 mr-1">
                <i class="fa fa-spin fa-spinner"></i>
            </span>
        </button>
    </mat-dialog-actions>
</form>
